import { render, staticRenderFns } from "./EmbedWidget.vue?vue&type=template&id=42e76164&scoped=true"
import script from "./EmbedWidget.vue?vue&type=script&lang=js"
export * from "./EmbedWidget.vue?vue&type=script&lang=js"
import style0 from "./EmbedWidget.vue?vue&type=style&index=0&id=42e76164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e76164",
  null
  
)

export default component.exports